import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '@material/material.module';

import { BatchItemSelectorDirective } from './batch-item-selector.directive';
import { BatchOperationToolbarComponent } from './components/batch-operation-toolbar.component';

const components = [
  BatchOperationToolbarComponent,
  BatchItemSelectorDirective,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    MaterialModule,
  ],
  exports: components,
})
export class BatchOperationToolbarModule { }
